import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}
const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

export const postZone = (name, symbol, description, zone_type, zone_id, warehouse_id, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log('warehouse_id',warehouse_id)
        let body = {
            name: name,
            symbol: symbol,
            description: description,
            warehouse_zone_type_id: zone_type,
            warehouse_id: warehouse_id
        }
        if (zone_id !== null) {
            body = {
                ...body,
                warehouse_zone_id: zone_id
            };
        }
        console.log('body',body)
        axios.post(`${END_POINT}/api/warehouses/zones`,
            body
            , {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(add(types.ADD_ZONE));
                    dispatch(loadZonesByWarehouse(warehouse_id));
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}
export const loadZones = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/warehouses/zones`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_ZONES));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const loadZonesByWarehouse = (warehouse_id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        console.log('warehouse_id',warehouse_id)
        axios.get(`${END_POINT}/api/warehouses/${warehouse_id}/zones`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_ZONES_BY_WAREHOUSE));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}

export const emptyZonesByWarehouse = () => {
    console.log('emptyyyyyyyyyyyyyyyyy')
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_ZONES_BY_WAREHOUSE))
    }
}

export const deleteZone = (id,warehouse_id, setloadDel) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/warehouses/zones/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_ZONE));
                loadZonesByWarehouse(warehouse_id)
                notifysuccess(res.data.message)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putZone = (id,name, symbol, description, zone_id, warehouse_id,warehouse_zone_type_id, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        let body = {
            name: name,
            symbol: symbol,
            description: description,
            warehouse_zone_type_id: warehouse_zone_type_id,
            warehouse_id: warehouse_id,
            //warehouse_zone_id: zone_id
        }
        axios.put(`${END_POINT}/api/warehouses/zones/${zone_id}`,body
            , {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(edit(types.EDIT_ZONE));
                    dispatch(loadZonesByWarehouse(warehouse_id));
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}


export const setLoadZoneWithoutWarehouseId = () => {
    return ({
        type: types.LOAD_ZONE_WAREHOUSE,
    })
}






